import { Col, Sidepanel, Spinner2 } from 'components';
import { Api, theme } from 'lib';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ContentHeader } from 'screens/Admin/components';
import styled from 'styled-components';
import { Settings, Story } from './components';

const UploadingOverlay = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 100%;
  z-index: 1;
  background-color: rgba(210, 216, 223, 0.7);
`;

const StoryPanel = ({ dataId, setDataId, closeModal, hasBack }) => {
  const [visible, setVisible] = useState(null),
    [loading, setLoading] = useState(false),
    storedData = useSelector((state) => state.admin?.stories?.find((x) => x._id === dataId)),
    dispatch = useDispatch();

  async function handleRemove() {
    const res = await Api.post('/admin/removeData', { type: 'StoryItem', id: dataId });
    if (!res) return;

    closeModal();

    dispatch({
      type: 'ADMIN_REMOVE_DATA',
      payload: dataId
    });
  }

  return (
    <React.Fragment>
      <Sidepanel wid={600} pad="0" visible={dataId} closeModal={closeModal}>
        <ContentHeader
          text={
            !storedData
              ? 'Create new story'
              : `Editing ${storedData?.owner?.name || storedData?.owner?.username}'s story`
          }
          SettingsComponent={() => (
            <Settings
              story={storedData}
              closeModal={() => setDataId(null)}
              visible={visible}
              setVisible={setVisible}
              loading={loading}
            />
          )}
          closePanel={hasBack && closeModal}
        />

        {dataId && (typeof dataId === 'string' ? !storedData : false) && (
          <Col
            zIndex={5}
            pos="absolute"
            ht="100%"
            wid="100%"
            bg="rgba(210, 216, 223, 0.7)"
            left="0"
            centerAll
          >
            <Spinner2 col={theme.SECONDARY} />
          </Col>
        )}

        {dataId && (typeof dataId === 'string' ? storedData : true) && (
          <Story
            story={storedData}
            setDataId={setDataId}
            closeModal={closeModal}
            isEditing={!!storedData}
            setVisible={setVisible}
            visible={visible}
            handleRemove={handleRemove}
          />
        )}
      </Sidepanel>
    </React.Fragment>
  );
};

export default StoryPanel;
